export default {
  locationDatabase: 'Database Lokasi',
  searchText: 'Cari Nama Lokasi',
  create: 'Buat Lokasi Baru',
  edit: 'Ubah Detil Lokasi',
  name: 'Nama Lokasi',
  address: 'Alamat',
  position: 'Posisi',
  latitude: 'Latitude:',
  longitude: 'Longitude:',
  province: 'Provinsi',
  city: 'Kodya/Kabupaten',
  district: 'Kecamatan',
  subDistrict: 'Kelurahan',
  // urbanVillage: 'Kelurahan',
  radius: 'Radius',
  openingTime: 'Jam Buka',
  closingTime: 'Jam Tutup',
  locationNote: 'Catatan Lokasi',
}
